module.exports = __webpack_public_path__ + "img/Warlock-undead-f-70.d3f2ec9d.gif";